module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEIAAAAiBAMAAAAZjhKBAAAAD1BMVEX///////////////////+Rd1MVAAAABHRSTlMAEJ/PUreMHgAAADdJREFUOMtjYMAOGI0YCAAmFwUCKhhNnAgZIjxqyCA3xIUAcCJCBYVOJezSUSMGmxFElA7wEgYAByUfu+nBXwMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// /opt/buildhome/repo/src/assets/images/arrows/cursor-right-light-2x.png
// module id = ../../../../../src/assets/images/arrows/cursor-right-light-2x.png
// module chunks = styles